@if (model()) {
  <formly-form [form]="form" [fields]="fields()" [model]="model()" [options]="options"></formly-form>
}
